import PageHeader from '../../components/PageHeader';
import './CardSpendingLimits.scss';

const SPENDING_LIMITS_MOCK = [
	{
		id: 'daily',
		title: 'Daily',
		value: '10000',
		description: 'The total number of transactions per day should not exceeded the set limit.',
	},
	{
		id: 'monthly',
		title: 'Monthly',
		value: '50000',
		description: 'The total number of transactions per month should not exceeded the set limit.',
	},
	{
		id: 'single',
		title: 'Single',
		value: '15000',
		description: 'If the amount of one transaction exceeds the specified limit, the payment will not go trough.',
	},
];

const CardSpendingLimits = () => {
	const limits = SPENDING_LIMITS_MOCK;

	const formatCurrency = value => {
		if (typeof value !== 'number') return '';

		return `$ ${value.toLocaleString('en-US', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})}`;
	};

	return (
		<div className='CardSpendingLimits'>
			<PageHeader header='Spending limits' />
			<div className='CardSpendingLimit__body'>
				{limits.map(item => (
					<div key={item.key} className='CardSpendingLimit__item-wrapper'>
						<div className='FormBlock CardSpendingLimit__item'>
							<p>{item.title}</p>
							<p>{formatCurrency(Number(item.value))}</p>
						</div>
						<div className='CardSpendingLimit__item-description'>
							<p>{item.description}</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default CardSpendingLimits;
